<template>
  <div class="Others5Charts">
    <div class="people-nums">
      <div
        class="place-data"
        :style="{ marginTop: `${$w_Ratio(6 + getShowfontSizeBase(), $store)}px` }"
        :class="getStyle('Style')"
        v-for="(item, index) in data"
        :key="index"
      >
        <div
          class="people-in"
          :style="{
            fontSize: `${$w_Ratio(1 + getShowfontSizeBase(), $store)}px`,
          }"
        >
          <p :style="getPadding(-4, -4)"><span></span> {{ item.s }}总入人数：</p>
          <div :style="getPadding(-8, -4)">
            <span :style="{ fontSize: `${$w_Ratio(10 + getShowfontSizeBase(), $store)}px` }">
              {{ item.x }}
            </span>
            <span>人</span>
          </div>
        </div>
        <div
          class="people-out"
          :style="{
            fontSize: `${$w_Ratio(1 + getShowfontSizeBase(), $store)}px`,
          }"
        >
          <p :style="getPadding(-4, -4)"><span></span> {{ item.s }}总出人数：</p>
          <div :style="getPadding(-8, -4)">
            <span :style="{ fontSize: `${$w_Ratio(10 + getShowfontSizeBase(), $store)}px` }">
              {{ item.x }}
            </span>
            <span>人</span>
          </div>
        </div>
        <!-- 线 -->
        <div class="line"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '../../../common/request';
export default {
  name: 'Others5Charts',
  components: {},
  props: {
    ProjectInfo: Object,
    Configuration: Object,
  },
  data() {
    return {
      echartsOptions: {},
      apiIntervalTaskID: null,
      staticIntervalTaskID: null,
      data: [],
      loading: true, // 加载对象
    };
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function () {
        if (this.Configuration.isScaling) {
          console.log('scale');
        } else if (this.Configuration.isMoving) {
          console.log('mov');
        } else {
          this.debounce_subscribeConfigurationChange();
        }
      },
    },
  },
  created() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);
    this.registerDebounceAndThrottle();
  },
  beforeMount() {},
  mounted() {
    this.$nextTick(() => {
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    });
    this.getApiDataResByFilterAndResponseQuery();
    // this.setStyle();
  },
  beforeUnmount() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);
    this.unRegisterDebounceAndThrottle();
  },
  computed: {
    style() {
      return this.ProjectInfo.Style.componentName;
    },
  },
  methods: {
    getPadding(a, b) {
      return {
        padding: `${this.$w_Ratio(a + this.getShowfontSizeBase(), this.$store)}px 
               ${this.$w_Ratio(b + this.getShowfontSizeBase(), this.$store)}px`,
      };
    },
    getStyle(e = '') {
      let style = {};
      let bool = e == 'title';
      switch (this.style) {
        case 'V1Style':
          style = {};
          if (bool) style['V1StyleTitle'] = true;
          style['V1Style'] = true;
          break;
        case 'V2Style':
          style = {};
          if (bool) style['V2StyleTitle'] = true;
          style['V2Style'] = true;
          break;
        case 'V3Style':
          style = {};
          if (bool) style['V3StyleTitle'] = true;
          style['V3Style'] = true;
          break;
        case 'V4Style':
          style = {};
          if (bool) style['V4StyleTitle'] = true;
          style['V4Style'] = true;
          break;
        case 'V5Style':
          style = {};
          if (bool) style['V5StyleTitle'] = true;
          style['V5Style'] = true;
          break;
        case 'V6Style':
          style = {};
          if (bool) style['V6StyleTitle'] = true;
          style['V6Style'] = true;
          break;
        case 'V7Style':
          style = {};
          if (bool) style['V7StyleTitle'] = true;
          style['V7Style'] = true;
          break;
        case 'V8Style':
          style = {};
          if (bool) style['V8StyleTitle'] = true;
          style['V8Style'] = true;
          break;
        case 'V9Style':
          style = {};
          if (bool) style['V9StyleTitle'] = true;
          style['V9Style'] = true;
          break;
        default:
          break;
      }
      return style;
    },
    // 根据不同的风格取不同的颜色
    setStyle() {
      let color;
      switch (this.style) {
        case 'V1Style':
          color = '#eee';
          break;
        case 'V2Style':
          color = '#eee';
          break;
        case 'V3Style':
          color = '#7fdfff';
          break;
        case 'V4Style':
          color = '#b044f8';
          break;
        case 'V5Style':
          color = '#09af60';
          break;
        default:
          color = '#eee';
          break;
      }
      this.$refs['loading-box'].style.setProperty('--color', color); // 给变量赋值
    },
    getShowfontSizeBase() {
      return Math.round(this.Configuration.style.height / 20);
    },
    registerDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange = this.$_.debounce(this.subscribeConfigurationChange, 500);
    },
    unRegisterDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange.cancel();
    },
    // 订阅Configuration变化将会执行的函数
    subscribeConfigurationChange() {
      clearInterval(this.apiIntervalTaskID);
      clearInterval(this.staticIntervalTaskID);
      clearInterval(this.staticIntervalTaskID2);
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    },
    setEchartsOptions(ParamData = null) {
      let grid = {};
      let chartColor = [];
      let source = [];
      let seriesList = [];
      let fontStyle = {
        titleColor: '#ccc',
        titleSize: 16,
        xAxisColor: '#c3dbff',
        xAxisSize: 12,
        yAxisColor: '#c3dbff',
        yAxisSize: 12,
      };

      if (this.Configuration.propertyData.chartsColor.value.chartColor) {
        chartColor = this.Configuration.propertyData.chartsColor.value.chartColor;
      }
      if (this.Configuration.propertyData.chartsGrid.value) {
        grid = this.Configuration.propertyData.chartsGrid.value;
      }
      if (ParamData && ParamData.source && ParamData.seriesList) {
        source = ParamData.source;
        seriesList = ParamData.seriesList;
      }
      if (this.Configuration.propertyData.fontStyle.value) {
        fontStyle = this.Configuration.propertyData.fontStyle.value;
      }
      this.data = source;
      // 关闭加载
      this.$nextTick(() => {
        // this.loading.close();
        this.loading = false;
        // console.log('关闭加载', this.loading.close);
      });

      console.log(source);
      console.log(seriesList);
      console.log(chartColor);
      console.log(fontStyle);
      console.log(grid);

      let xData = [];
      let yData = [];
      let xyData = [];
      let unit = '';

      function DealData() {
        seriesList.forEach(s => {
          source.forEach((item, index) => {
            if (s === item.s) {
              unit = item.s;
              if (index >= 4) return;
              xData.push(item.x);
              yData.push(item.y);

              xyData.push({
                name: item.x,
                value: parseInt(item.y),
              });
            }
          });
        });
      }

      // DealData();
      // console.log('------------------------------------aaaa');
      // console.log(xyData);
      // this.data1.unit = unit;
      // this.data2.unit = unit;
      // this.data3.unit = unit;

      // if (xyData[0]) {
      //   this.data1.name = xyData[0].name;
      //   this.data1.value = xyData[0].value;
      // }
      // if (xyData[1]) {
      //   this.data2.name = xyData[1].name;
      //   this.data2.value = xyData[1].value;
      // }
      // if (xyData[2]) {
      //   this.data3.name = xyData[2].name;
      //   this.data3.value = xyData[2].value;
      // }

      // console.log(unit);
    },
    // 开启静态任务 数据是静态的
    startStaticIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let chartsAnimation = this.Configuration?.propertyData?.chartsAnimation?.value;
      if (ChartsData?.currenEntry === 'staticData' && chartsAnimation?.isUseStaticRefresh) {
        // console.log('使用静态任务');
        let func = () => {
          let data = this.$_.cloneDeep(ChartsData.staticData);

          this.setEchartsOptions(data);
        };
        clearInterval(this.staticIntervalTaskID);
        func();

        this.staticIntervalTaskID = setInterval(() => {
          console.log('任务执行staticData');
          console.log(chartsAnimation);
          func();
        }, chartsAnimation?.staticRefreshIntervalTime * 1000);

        this.staticIntervalTaskID2 = setInterval(() => {
          func();
        }, (chartsAnimation?.staticRefreshIntervalTime - 2 <= 0 ? 1 : chartsAnimation?.staticRefreshIntervalTime - 2) * 1000);
      } else if (ChartsData?.currenEntry === 'staticData') {
        console.log('无静态任务 执行staticData');
        this.setEchartsOptions(ChartsData.staticData);
      }
    },
    // 开启api动态任务 数据是动态的
    async startApiIntervalTask() {
      // 加载
      // debugger
      // this.loading = null
      // this.loading = ElLoading.service({
      //   target: this.$refs.people_num,
      //   text: '加载中...',
      //   background: 'transparent',
      //   customClass: this.getStyle('Loading'),
      // });
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      // 判断是否使用apiData，使用动态interval请求
      if (ChartsData?.currenEntry === 'apiData' && ChartsData?.apiData?.isUseInterval) {
        // 开启interval任务 间隔请求
        let func = async () => {
          let res = await this.getApiDataResByFilterAndResponseQuery();
          this.setEchartsOptions(res);
          // this.loading.close();
        };
        func();
        this.apiIntervalTaskID = setInterval(async () => {
          // console.log('开启interval任务 间隔请求');
          func();
        }, ChartsData?.apiData?.apiInterval * 1000);
        // console.log(ChartsData?.apiData?.apiInterval);
      } else if (ChartsData?.currenEntry === 'apiData') {
        // console.log('不开启interval任务 只处理一次请求');
        let res = await this.getApiDataResByFilterAndResponseQuery();
        this.setEchartsOptions(res);
        // this.loading.close();
      }
    },
    // promise 返回api链接的请求数据
    getApiDataRes() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let that = this;
      return new Promise((resolve, reject) => {
        if (!ChartsData) resolve('Error ChartsData 不存在！');
        if (!ChartsData.apiData?.apiUrl) resolve('Error apiUrl 不存在！');
        let header;
        if (ChartsData.apiData?.isUseUserKey) {
          let user_key = localStorage.getItem('user_key');

          if (user_key == 'undefined' || user_key == 'null' || user_key == null) user_key = this.$userKey;
          header = {
            userkey: user_key,
          };
        } else {
          header = {};
        }
        if (ChartsData.apiData?.apiUrlMethod == 'get') {
          let params = ChartsData.apiData.apiPostParams || '{}';
          // this.axios({
          //   method: ChartsData.apiData.apiUrlMethod,
          //   url: ChartsData.apiData.apiUrl,
          //   params: eval('(' + params + ')'),
          //   headers: header,
          // })
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: eval('(' + params + ')'),
            headers: header,
          };

          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        } else {
          let params = ChartsData.apiData.apiPostParams || '{}';
          // this.axios({
          //   method: ChartsData.apiData.apiUrlMethod,
          //   url: ChartsData.apiData.apiUrl,
          //   data: eval('(' + params + ')'),
          //   headers: header,
          // })
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            data: eval('(' + params + ')'),
            headers: header,
          };

          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery
    getApiDataResByResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // console.log('getApiDataResByResponseQuery');
            // console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery和过滤器函数
    getApiDataResByFilterAndResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        let filter = function (data, filter_text) {
          let dataSet = {};
          eval(filter_text);
          return dataSet;
        };
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // 判断是否使用过滤器
            if (ChartsData.apiData.isUseFilter) {
              res = filter(res, ChartsData.apiData.apiFilter);
            }
            // console.log('getApiDataResByFilterAndResponseQuery');
            // console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
  },

  Configuration: {
    componentTitle: '多行文字',
    componentName: 'Others5Charts',
    componentOverViewImg: './img/charts/OthersCharts/Others5Charts.png',
    id: '',
    style: {
      width: 462,
      height: 194,
      left: 0,
      top: 0,
    },
    isScaling: false,
    isMoving: false,
    propertyData: {
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },

      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts1Border',
        },
      },
      chartsColor: {
        propertyComponentName: 'ArrayColorSelector',
        value: {
          chartColor: [
            'rgba(223,65,56,1)',
            'rgba(229,115,63,1)',
            'rgba(240,189,108,1)',
            'rgba(237,214,102,1)',
            'rgba(77,168,222,1)',
            'rgba(25,168,164,1)',
          ],
          chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
        },
      },
      ChartsData: {
        lable: '数据接入',
        propertyComponentName: 'ChartsDataConfigor',
        value: {
          currenEntry: 'staticData',
          apiData: {
            apiUrl:
              'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
            // apiUrl:
            // 'http://192.168.0.173/gthmmc_v4.0/gthmmc/index.php?m=sdms&c=dataMange&a=completeStatisticsdata&data=%7B%22type%22:%22%E6%80%BB%E6%95%B0%22,%22date_start%22:%222021-03-01%22,%22date_end%22:%222021-03-31%22%7D&directory_code=pro_ownerstatistics&type=day',
            apiResponseQuery: 'data.forecasts',
            isUseFilter: true,
            apiFilter: `
          // 可以使用data访问api请求的响应结果        
let seriesList = []

let seriesListKey = 'city'
let seriesListChildrenKey = 'casts'

data.forEach((item) => {
  seriesList.push(item[seriesListKey])
})
dataSet.seriesList = seriesList
dataSet.source = []
data.forEach((item) => {
  item[seriesListChildrenKey].forEach(item2 => {
    dataSet.source.push({
      s: item[seriesListKey],
      x: item2.date,
      y: item2.daytemp
    })
  })
})
          `,
            apiUrlMethod: 'get',
            isUseInterval: true,
            apiInterval: 10,
          },
          staticData: {
            seriesList: ['测试', '测试1'],
            source: [
              {
                s: '测试',
                x: 200,
                y: 100,
              },
              {
                s: '测试1',
                x: 2001,
                y: 1010,
              },
            ],
          },
        },
      },
      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 450,
          height: 200,
          left: 0,
          top: 0,
        },
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#ccc',
        },
      },
      chartsGrid: {
        lable: '图表定位',
        propertyComponentName: 'ChartsGridConfiger',
        value: {
          left: '5%',
          right: '10%',
          bottom: '0%',
          top: '0%',
        },
      },
      showStatus: {
        value: 'norm',
      },
      chartsOpicity: {
        propertyComponentName: 'ChartsOpicityConfiger',
        value: 1,
      },
      chartsAnimation: {
        propertyComponentName: 'ChartsAnimationConfiger',
        value: {
          isUseAnimation: false,
          isUseStaticRefresh: false,
          staticRefreshIntervalTime: 5,
        },
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.Others5Charts {
  color: white;
  // background-color: rgba(8, 27, 49, 0.842);
  background-color: transparent !important;
  width: 100%;
  height: 100%;
  border-radius: 2px;
  .place-data {
    // width: 100%;
    margin-top: 10px;
    margin-left: 4px;
    display: flex;
    align-items: center;
  }
  .people-nums {
    overflow-y: scroll;
    max-height: 400px;
  }
  .people-in,
  .people-out {
    width: 50%;
    display: flex;
    justify-content: space-around;
  }
  .people-out {
    margin-left: 10px;
  }
  .line {
  }
  .V1Style {
    div {
      align-items: center;
      div {
        span:nth-child(1) {
          color: transparent;
          background: linear-gradient(to bottom, #fefa00, #ff7400);
          -webkit-background-clip: text;
          background-clip: text;
          font-weight: bold;
          font-style: italic;
          padding-right: 6px;
        }
      }
    }
    .people-in {
      // display: inline-block;
      // *display: flex;
      // *zoom: 1;
      background: #314f9194;
      border-radius: 10px;
      width: 70%;
      &::before {
        content: '';
        top: 0;
        left: 0;
        width: 2px;
        height: 20px;
        background: linear-gradient(to bottom, #353adb, #00dcff);
      }
    }
    .people-out {
      background: #314f9194;
      border-radius: 10px;
      width: 70%;
      &::before {
        content: '';
        top: 0;
        left: 0;
        width: 2px;
        height: 20px;
        background: linear-gradient(to bottom, #353adb, #00dcff);
      }
    }
  }
  .V2Style {
    div {
      p {
        background: radial-gradient(circle, #2c4c40, transparent);
      }
    }
    div {
      span:nth-child(1) {
        color: transparent;
        background: linear-gradient(to bottom, #fefa00, #ff7400);
        -webkit-background-clip: text;
        background-clip: text;
        font-weight: bold;
        font-style: italic;
        padding-right: 6px;
      }
    }
  }
  .V3Style {
    background: none !important;
    div {
      align-items: center;
      div {
        // padding: 12px 30px 12px 30px;
        span:nth-child(1) {
          color: transparent;
          background: linear-gradient(to bottom, #fefa00, #ff7400);
          -webkit-background-clip: text;
          background-clip: text;
          font-weight: bold;
          font-style: italic;
          padding-right: 6px;
        }
      }
    }
    .people-in {
      background: #0040ca94;
      border-radius: 10px;
      width: 70%;
      &::before {
        content: '';
        top: 0;
        left: 0;
        width: 2px;
        height: 20px;
        background: linear-gradient(to bottom, #fefa00, #ff7400);
      }
    }
    .people-out {
      background: #0040ca94;
      border-radius: 10px;
      width: 70%;
      &::before {
        content: '';
        top: 0;
        left: 0;
        width: 2px;
        height: 20px;
        background: linear-gradient(to bottom, #00fcf6, #019032);
      }
    }
  }
  .V4Style {
    background: none !important;
    div {
      display: flex;
      align-items: center;
      p {
        display: flex;
        justify-content: center;
        align-items: center;
        display: block;
        background: url('/img/charts/OthersCharts/chartTitle/purple_title.png') no-repeat;
        background-size: 100% 100%;
        // padding: 12px 30px;
        // span {
        //   display: inline-block;
        //   width: 5px;
        //   height: 5px;
        //   border-radius: 50%;
        //   box-shadow: 0 0 6px #f1ef73;
        //   background: #fffb46;
        //   margin-right: 10px;
        // }
      }
      div {
        background: url('/img/charts/OthersCharts/chartTitle/purple_right.png') no-repeat;
        background-size: 100% 100%;
        // padding: 12px 30px 12px 30px;
        span:nth-child(1) {
          color: transparent;
          background: linear-gradient(to bottom, #fefa00, #ff7400);
          -webkit-background-clip: text;
          background-clip: text;
          font-weight: bold;
          font-style: italic;
          padding-right: 6px;
        }
      }
    }
  }
  .V5Style {
    background: none !important;
    div {
      // display: flex;
      align-items: center;
      p {
        display: flex;
        justify-content: center;
        align-items: center;
        // padding: 8px 20px;
        background: radial-gradient(circle, #09af60, transparent);
        span {
          display: inline-block;
          width: 5px;
          height: 5px;
          border-radius: 50%;
          box-shadow: 0 0 6px #f1ef73;
          background: #fffb46;
          margin-right: 10px;
        }
      }
      div {
        span:nth-child(1) {
          color: #fffb46;
          font-weight: bold;
        }
      }
    }
  }
  .V6Style {
    div {
      align-items: center;
    }
    .people-in {
      border-radius: 10px;
      background: #3c624647;
      background-size: 100% 100%;
      &::before {
        content: '';
        top: 0;
        left: 0;
        width: 4px;
        height: 4px;
        background: linear-gradient(to bottom, #fefa00, #ff7400);
      }
    }
    .people-out {
      border-radius: 10px;
      background: #3c624647;
      background-size: 100% 100%;
      &::before {
        content: '';
        top: 0;
        left: 0;
        width: 4px;
        height: 4px;
        background: linear-gradient(to bottom, #fefa00, #ff7400);
      }
    }
    div {
      span:nth-child(1) {
        color: transparent;
        background: linear-gradient(to bottom, #fefa00, #ff7400);
        -webkit-background-clip: text;
        background-clip: text;
        font-weight: bold;
        font-style: italic;
        padding-right: 6px;
      }
    }
  }
  .V7Style {
    .people-in {
      background: url('/img/charts/OthersCharts/chartTitle/V7_title.png') no-repeat;
      background-size: 100% 100%;
    }
    .people-out {
      background: url('/img/charts/OthersCharts/chartTitle/V7_title.png') no-repeat;
      background-size: 100% 100%;
    }
    div {
      span:nth-child(1) {
        color: transparent;
        background: linear-gradient(to bottom, #fefa00, #ff7400);
        -webkit-background-clip: text;
        background-clip: text;
        font-weight: bold;
        font-style: italic;
        padding-right: 6px;
      }
    }
  }
  .V8Style {
    color: #000;
    background: #fff !important;
    border-radius: 4px;
    div {
      p {
        background: radial-gradient(circle, #afeffc, transparent) no-repeat;
        background-size: 100% 100%;
      }
      span:nth-child(1) {
        color: #011c09;
        font-weight: bold;
        -webkit-background-clip: text;
        background-clip: text;
        font-style: italic;
        padding-right: 6px;
      }
    }
  }
  .V9Style {
    div {
      p {
        background: radial-gradient(circle, #a5b8bb, transparent);
        background: url('/img/charts/OthersCharts/chartTitle/V9_title.png') no-repeat;
        background-size: 100% 100%;
      }
    }
    div {
      span:nth-child(1) {
        color: transparent;
        background: linear-gradient(to bottom, #fefa00, #ff7400);
        -webkit-background-clip: text;
        background-clip: text;
        font-weight: bold;
        font-style: italic;
        padding-right: 6px;
      }
    }
  }
}
// 加载样式

:deep().el-loading-spinner {
  .path {
    stroke: var(--color) !important;
  }
  p {
    display: flex !important;
    align-items: center !important;
    color: var(--color) !important;
  }
}

/**滚动条的宽度*/
::-webkit-scrollbar {
  width: 0px; //padding-left: 10px;
}
//滚动条的滑块
::-webkit-scrollbar-thumb {
  background-color: #7174729a;
  border-radius: 3px;
}
</style>
